exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kpi-divider[data-v-837a773c]{margin:.5rem 0 1rem}.kpi-card[data-v-837a773c]{height:100%;display:flex;flex-direction:column}.kpi-header[data-v-837a773c]{display:flex;align-items:center;gap:.5rem}.kpi-header .title[data-v-837a773c]{min-width:0;overflow-wrap:break-word;word-break:normal;font-size:.9rem}.kpi-value[data-v-837a773c]{font-size:2.5rem;font-weight:700;line-height:1}.kpi-extra[data-v-837a773c]{font-size:.875rem;color:#656565;font-weight:400}.kpi-values[data-v-837a773c]{margin-bottom:.5rem}.kpi-card>p[data-v-837a773c]{margin-top:auto;margin-bottom:0}.kpi-subtitle[data-v-837a773c]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-837a773c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/climan/components/kpiCard.vue
// module id = 1450
// module chunks = 2